import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import apiUrl from "../api";

import axios from "axios";

const AddTransactionReason = () => {
  const [transactionName, setTransactionName] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleAddCategory = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (transactionName === "") {
      return setError("Transaction name is required.");
    }

    // Add your API call here to add the category
    try {
      const response = await axios.post(

        `${apiUrl}/transaction-reason/`,
        {
          title: transactionName,

        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Transaction Reason added successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Transaction Reason already exists.");
      } else {
        setError("Failed to add transaction reason. Please try again.");
      }
    }

    setTransactionName("");
   
  };

  return (
    <div className="add-category-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "0px",
          fontWeight: "600",
        }}
      >
        Add Transaction Reason
      </h4>
      <form
        onSubmit={handleAddCategory}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          alignItems: "center",
        }}
      >
        <TextField
          variant="outlined"
          label="Transaction Reason Name"
          placeholder="Transaction Reason Name"
          value={transactionName}
          onChange={(e) => setTransactionName(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
          }}
        />
       
        <button
          className="add-ticket-button__button"
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: "auto",
            padding: "10px 20px",
          }}
          onClick={() => {}}
        >
          <AddIcon />
          <span>Add</span>
        </button>
      </form>
    </div>
  );
};

export default AddTransactionReason;
